import { render } from "./GenomeViewer.vue?vue&type=template&id=7bbd232d"
import script from "./GenomeViewer.vue?vue&type=script&lang=js"
export * from "./GenomeViewer.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__